import { EntityItemRecord } from '@/entities/entityItem';
import { EntityTypeProperty, PropertyDataType } from '@/entities/entityTypeProperty';

export const getPropertyValue = (row: EntityItemRecord, property: EntityTypeProperty) => {
  const propValue = row.data.properties.find(
    p => p.entityTypePropertyId === property.id,
  );

  if (!propValue) {
    return '—';
  }

  if (property.dataType === PropertyDataType.Text) {
    return propValue.valueText || '—';
  }

  if (property.dataType === PropertyDataType.Dropdown && property.optionSet) {
    const selectedOptions = propValue.optionValueIds || [];
    const labels = selectedOptions
      .map(id => {
        const option = property.optionSet?.optionValues.find(ov => ov.id === id);

        return option?.label;
      })
      .filter(Boolean)
      .join(', ');

    return labels || '—';
  }

  return '—';
};
